import { makeAutoObservable, observable, runInAction, action } from "mobx";

export class HoveringState {
  hovering = false;
  hoveredRect: DOMRect | null = null;

  constructor() {
    makeAutoObservable(this, {
      hovering: observable,
      setHoveredRect: action,
    });
  }

  private hoveringDelayed = false;
  private timeoutHandle = 0;

  setHoveredRect(rect: DOMRect | null) {
    this.hoveredRect = rect;
  }

  setHoveringDelayed = (hovering: boolean) => {
    if (this.hoveringDelayed === hovering) {
      return;
    }

    clearTimeout(this.timeoutHandle);
    this.hoveringDelayed = hovering;
    this.timeoutHandle = window.setTimeout(runInAction, 300, () => {
      this.hovering = this.hoveringDelayed;
    });
  };

  handleMouseLeave = () => {
    this.setHoveringDelayed(false);
  };

  handleMouseEnter = () => {
    this.setHoveringDelayed(true);
  };
}
